export const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000/featured"
    : process.env.REACT_APP_BASEURL_PROD;

export const FbFunctionsEndpoint =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_FB_FUNCTIONS_ENDPOINT_DEV
    : process.env.REACT_APP_FB_FUNCTIONS_ENDPOINT_PROD;
